import { observer } from 'mobx-react-lite'
import { useId } from 'react'
import { type ResetPasswordViewModel } from './ResetPasswordViewModel'
import { FormContainer } from '@/components/FormContainer'
import { TextFieldContainer } from '@/components/inputs/TextFieldContainer'
import {
  ResetPasswordDialog,
  PasswordResetForm,
  PasswordResetSuccess,
} from './index'

export interface ResetPasswordDialogContainerProps {
  vm: ResetPasswordViewModel
}

export const ResetPasswordDialogContainer = observer(
  function ResetPasswordDialogContainer({
    vm,
  }: ResetPasswordDialogContainerProps) {
    const formId = useId()

    return (
      <ResetPasswordDialog
        isOpen={vm.modal.showing}
        isDismissable={!vm.submit.pending}
        onClose={vm.close}
      >
        {vm.submitted ? (
          <PasswordResetSuccess email={vm.email} onClose={vm.close} />
        ) : (
          <PasswordResetForm
            formId={formId}
            isPending={vm.submit.pending}
            onCancel={vm.modal.close}
          >
            <FormContainer compact id={formId} onSubmit={vm.submit}>
              <TextFieldContainer
                model={vm}
                type="email"
                field="email"
                placeholder="example@email.com"
              />
            </FormContainer>
          </PasswordResetForm>
        )}
      </ResetPasswordDialog>
    )
  },
)
